const initialState = {
    commitmentOrCertificateNumber: "",
    lenderLoanNumber: "",
    applicationType: "",
    status: "",
    statusMessage: "",
    receivedDate: "",
    receivedTime: "",
    pendedReasons: [],
    suspendReason: ""
};

export default function loanStatusReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_COMMITMENT_OR_CERTIFICATE_NUMBER':
            return {
                ...state,
                commitmentOrCertificateNumber: action.payload
            };
        case 'SET_LENDER_LOAN_NUMBER':
            return {
                ...state,
                lenderLoanNumber: action.payload
            };
        case 'SET_APPLICATION_TYPE':
            return {
                ...state,
                applicationType: action.payload
            };
        case 'SET_STATUS':
            return {
                ...state,
                status: action.payload
            };
        case 'SET_STATUS_MESSAGE':
            return {
                ...state,
                statusMessage: action.payload
            };
        case 'SET_RECEIVED_DATE':
            return {
                ...state,
                receivedDate: action.payload
            };
        case 'SET_RECEIVED_TIME':
            return {
                ...state,
                receivedTime: action.payload
            };
        case 'SET_LAST_DOC_RECEIVED_DATE':
            return {
                ...state,
                lastDocReceivedDateTime: action.payload
            };
        case 'SET_PENDED_REASONS':
            return {
                ...state,
                pendedReasons: action.payload
            };
        case 'ADD_PENDED_REASON':
            return {
                ...state,
                pendedReasons: [...state.pendedReasons, action.payload]
            };
        case 'SET_SUSPEND_REASON':
            return {
                ...state,
                suspendReason: action.payload
            };
        default:
            return state;
    }
};